
export class AttachmentCriteria {
ageGreaterThan: number | null;
createdAfter: number | null;
createdBefore: number | null;
extensionEquals: string;
nameContains: string;
nameStartWith: string;
path: string;
sizeGreaterThan: number | null;
updatedBefore: number | null;
}

